(() => {
  const selector = '#lm-rv-wrap .lm-rv-swiper';

  const configure = () => {
    const element = document.querySelector(selector);
    const carousel = element?.swiper;

    if (!carousel || carousel.lmContinuousConfigured) return;

    carousel.lmContinuousConfigured = true;
    carousel.allowTouchMove = false;
    carousel.params.allowTouchMove = false;
    carousel.params.speed = 8000;
    carousel.params.autoplay = {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
      reverseDirection: true,
      waitForTransition: true,
    };

    carousel.autoplay.stop();
    carousel.autoplay.start();
  };

  const initialize = () => {
    const wrapper = document.querySelector('#lm-rv-wrap .swiper-wrapper');

    if (!wrapper) return;

    configure();

    const section = document.querySelector('#lm-rv-wrap');

    if (section && !section.dataset.lmHoverPauseBound) {
      section.dataset.lmHoverPauseBound = 'true';
      section.addEventListener('mouseenter', () => {
        const activeCarousel = document.querySelector(selector)?.swiper;

        if (!activeCarousel) return;

        const currentPosition = activeCarousel.getTranslate();
        activeCarousel.autoplay.pause();
        activeCarousel.setTransition(0);
        activeCarousel.setTranslate(currentPosition);
        activeCarousel.updateProgress(currentPosition);
        activeCarousel.animating = false;
      });
      section.addEventListener('mouseleave', () => {
        const activeCarousel = document.querySelector(selector)?.swiper;

        if (!activeCarousel) return;

        activeCarousel.setTransition(0);
        activeCarousel.updateActiveIndex();
        activeCarousel.updateSlidesClasses();
        activeCarousel.animating = false;
        activeCarousel.autoplay.resume();
      });
    }

    new MutationObserver(configure).observe(wrapper, {
      childList: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
